// extracted by mini-css-extract-plugin
module.exports = {"baseFont":"LineClamp__baseFont__1F29u","base":"LineClamp__base__oF9Pd","baseColor":"LineClamp__baseColor__2IDXg","baseFontFamily":"LineClamp__baseFontFamily__2LcWE"};